import * as React from 'react'

import * as env from '@owl-nest/config'

import { Header as UniversalHeader } from './src/flavours/main'
import { Header as InternationalHeader } from './src/flavours/international'

export * as styles from './src/components/style'

import { type HeaderProps } from './src/types'

export { ConfigurationProvider } from './src/context/configuration/ConfigurationProvider'
export { UserDrawerProvider } from './src/context/userDrawer/UserDrawerProvider'
export * as subnavStyles from './src/subnavs/style'

export function Header(props: HeaderProps): any {
  const userConfig = env.useUserEnv()

  const lang = props.lang || userConfig.lang
  if (lang === 'fr') {
    return <UniversalHeader {...props} />
  }

  return <InternationalHeader {...props} />
}

export function LegacyCompatibleHeader(props: HeaderProps): any {
  return Header(props)
}
